import * as yup from 'yup';

const emailErrorMessage = 'The email format is invalid';

export const UserSchema = yup.object().shape({
  firstName: yup
    .string()
    .label('First name')
    .required('Invalid first name')
    .min(1)
    .max(100),
  lastName: yup
    .string()
    .label('Last name')
    .required('Invalid last name')
    .min(1)
    .max(100),
  email: yup
    .string()
    .label('Email')
    .required(emailErrorMessage)
    .email(emailErrorMessage),
});

export const SpaceCodeSchema = yup.object().shape({
  spaceCode: yup
    .string()
    .label('Space code')
    .required('Invalid space code')
    .length(6),
});
